import { render, staticRenderFns } from "./get_devis_from_form.vue?vue&type=template&id=2cd018b8&scoped=true"
import script from "./get_devis_from_form.vue?vue&type=script&lang=js"
export * from "./get_devis_from_form.vue?vue&type=script&lang=js"
import style0 from "./get_devis_from_form.vue?vue&type=style&index=0&id=2cd018b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd018b8",
  null
  
)

export default component.exports